<template>
    <div>
        <Chart :options="chartOptions" ref="barChart" />
    </div>
</template>



<script>

import Chart from 'vue2-highcharts'  

export default {
    name: 'BarChart',
    props: {
        context: {
            type: String,
            required: true
        },
        items: {
            type: Object,
            required: true
        }
    },
    components: {
        Chart
    },
    data() {
        return {
            quantity: []
        }
    },   
    computed: {
        chartOptions(){
            return {
                chart: {
                    type: 'column'
                },
                title: {
                    text: this.chartTitleText,
                    style : {
                        fontSize: '16px',
                        fontWeight: 'normal',
                        fontFamily: 'Roboto, sans-serif'
                    }
                },
                credits: {
                    enabled: false
                },
                yAxis: {
                    title: {
                        text: this.$t('lang_LABEL_STATISTICS_CAPTION_REVENUE') + ' ' + this.$store.getters.getSelectedCurrency,
                    }
                },
                xAxis: {
                    title: {
                        text: this.$t('lang_LABEL_STATISTICS_CHART_DROPDOWN_BY_MONTHS')
                    },
                    categories: this.items.xAxis,
                    crosshair: true,
                    accessibility: {
                        description: 'Countries'
                    }
                },
                legend: {
                    enabled: true
                },
                tooltip: {
                    headerFormat: '',
                    style : {
                        fontFamily: 'Roboto, sans-serif'
                    },
                    formatter:  function ()  {
                        const seriesIndex = this.series.index;
                        const pointIndex = this.point.index;
                        const revenue = this.series.chart.userOptions.series[seriesIndex].revenue[pointIndex]; 
                        const quantity = this.series.chart.userOptions.series[seriesIndex].quantity[pointIndex]
                        return '<b>'+this.series.chart.userOptions.series[seriesIndex].name+'</b><br>' + revenue +' <br> ' + quantity
                    }
                },
                plotOptions: {
                    column: {
                        pointPadding: 0,
                        groupPadding: 0.1,
                        borderWidth: 0
                    }
                },
                series: this.seriesData,
                responsive: {
                }
            }
        },
        chartTitleText(){
            var bar = this.$store.getters['getLabelStatisticsBarChart']
            var title = bar.title
            var titleText = '';
            if(title.text.length > 1){ 
                title.text.forEach(element => {
                    var elementText = this.$alvPlugin.isLangConst(element) ? this.$t(element) : element;
                    titleText = titleText + ' ' + elementText
                });
            }else{
                titleText = this.$alvPlugin.isLangConst(title.text[0]) ? this.$t(title.text[0]) : title.text[0];
            }
           
            return titleText;
        },
        seriesData(){
            var seriesData = this.items.series
            seriesData = seriesData.map((data) => { 
                let nameValue = data.name
                if(this.chartTitleValue === 'countries') {
                    nameValue = this.$alvPlugin.getTranslatedCountryCode(data.name)
                }else{
                    if(this.$alvPlugin.isLangConst(data.name)){
                        nameValue = this.$t(data.name)
                    }
                }
                return { 
                    name: nameValue,
                    color: data.color,
                    data: data.data,
                    revenue: data.data.map((element) => {
                        return  this.$t('lang_LABEL_STATISTICS_CAPTION_REVENUE') + ' : ' + this.$alvPlugin.getNumberLocalization(element, 'number') + ' ' + this.$store.getters.getSelectedCurrency
                    }),
                    quantity: data.quantity.map((element) => this.$t('lang_GENERIC_CAPTION_QUANTITY') + ' : ' +this.$alvPlugin.getNumberLocalization(element, 'number').slice(0, -3)),
                }
            })
            return seriesData
        }

    },
    methods: {
    }
}


</script>
<style>
    
</style>